import script from "./NotFoundMain.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundMain.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundMain.vue?vue&type=style&index=0&id=5f45c99e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f45c99e"]])

export default __exports__